import axios from 'axios'
import i18n from 'i18next'
import qs from 'qs'
import { bindActionCreators } from 'redux'

import store from '../index'
import { UsersActions } from '../redux/users.reducer'

const acceptMethods = ['facebook', 'google']

export const index = axios.create({
  baseURL: process.env.REACT_APP_API_GATEWAY_URL,
  paramsSerializer: (params) =>
    qs.stringify(params, { arrayFormat: 'repeat', encodeValuesOnly: true }),
})

index.interceptors.request.use(async (config) => {
  const paymentToken = sessionStorage.getItem('paymentToken')
  const isPaymentRoute = window.location.pathname.startsWith('/payment')

  let accessToken = localStorage.getItem('accessToken')

  if (!accessToken) {
    const state = store.getState()
    accessToken = state.user.userToken
  }

  const { method } = store.getState().user

  const userToken =
    paymentToken && isPaymentRoute
      ? { Authorization: `Bearer ${paymentToken}` }
      : accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : {}
  const userMethod = acceptMethods.includes(method) ? { provider: method } : {}

  const lang = i18n.language === 'pt-BR' ? 'pt_BR' : 'en_US'

  return {
    ...config,
    headers: {
      ...config.headers,
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': '*',
      v3: true,

      lang,
      ...userMethod,
      ...userToken,
    },
  }
})

index.interceptors.response.use(
  (response) => response,
  async (err) => {
    if (err?.response?.status === 401 && !err?.config?.url?.includes('login')) {
      const refreshToken = localStorage.getItem('refreshToken')
      const { logout, setToken } = bindActionCreators(
        UsersActions,
        store.dispatch
      )

      if (store.getState().user.method !== 'default') {
        logout()
        return Promise.reject(err)
      }

      try {
        const { accessToken, refreshToken: refreshed } = (
          await axios.post(
            `${process.env.REACT_APP_API_GATEWAY_URL}/users/login/refresh`,
            {
              refreshToken,
            }
          )
        ).data
        setToken(accessToken, refreshed)

        const config = {
          ...err.config,
          headers: {
            ...err.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        }

        try {
          const res = await axios.request(config)
          return Promise.resolve(res)
        } catch (e) {
          return Promise.reject(e)
        }
      } catch (e) {
        logout()
      }
    }

    return Promise.reject(err)
  }
)

export const apiMethods = async ({
  method,
  url,
  data,
  headers,
  params,
  ...props
}) => {
  const m = method.trim().toLowerCase()

  const hasPayload = ['post', 'put', 'patch', 'delete'].includes(m)
  const payload = hasPayload ? data ?? {} : undefined

  try {
    const response = await index.request({
      method: m,
      data: payload,
      url,
      headers: { ...headers },
      params,
      ...props,
    })
    return response
  } catch (error) {
    return {
      status: error.response?.status || 500,
      data: error.response?.data ?? { message: 'Request failed' },
      error: true,
    }
  }
}

export const createApiRequest = async ({
  method = 'get',
  url = '',
  data = {},
  headers = {},
  onSuccess = () => {},
  onFail = () => {},
  params = {},
  ...props
}) => {
  const request = await apiMethods({
    url,
    data,
    headers,
    method,
    params,
    ...props,
  })

  if (request?.error && onFail) await Promise.resolve(onFail(request))
  else if (onSuccess) await Promise.resolve(onSuccess(request))
  return request
}
